import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { CLIPBOARD_SCORE_FULL_PATH } from "@src/appV2/redesign/ClipboardScore/utils/paths";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { Card, Text } from "@src/appV2/redesign/system/ui-components";

import { type ScoreImpactResult } from "../hooks/useScoreImpact";

interface ScoreImpactSectionProps {
  readonly data: ScoreImpactResult;
}

export function ScoreImpactSection({ data }: ScoreImpactSectionProps) {
  const {
    currentScore,
    penaltyPoints,
    scoreAfterCancel,
    wouldRestrict,
    latenessMessage,
    timelinessMessage,
  } = data;

  if (!isDefined(currentScore)) {
    return null;
  }

  return (
    <Card variant="tertiary" sx={(theme) => ({ padding: theme.spacing(5) })}>
      <Stack spacing={3}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Text semibold variant="body1">
            Clipboard Score
          </Text>
          <Text semibold variant="body1">
            {currentScore}
          </Text>
        </Stack>

        {isDefined(penaltyPoints) && wouldRestrict && (
          <Text variant="body2">Cancelling now will lead to account restriction.</Text>
        )}

        {isDefined(penaltyPoints) && !wouldRestrict && (
          <Text variant="body2">
            Cancelling now will deduct {Math.abs(penaltyPoints)} points from your score, bringing it
            to {scoreAfterCancel}.
          </Text>
        )}

        {isDefined(latenessMessage) && <Text variant="body2">{latenessMessage}</Text>}

        {isDefined(timelinessMessage) && <Text variant="body2">{timelinessMessage}</Text>}

        {wouldRestrict ? (
          <TextButton href={CLIPBOARD_SCORE_FULL_PATH}>Learn about Restrictions</TextButton>
        ) : (
          <TextButton href={CLIPBOARD_SCORE_FULL_PATH}>View Policy</TextButton>
        )}
      </Stack>
    </Card>
  );
}
